module.exports = __webpack_public_path__ + "img/view-icon.49fca493.svg";